
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry-leader/large-firms",
      function () {
        return require("private-next-pages/industry-leader/large-firms/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry-leader/large-firms"])
      });
    }
  